import baseApi from '../utils/PlainApiUtils';

const setAuthUser = (response, dispatch) => {
  const token = {
    access_token: response?.data?.data?.access,
    refresh_token: response?.data?.data?.refresh,
  };
  localStorage.setItem('token', JSON.stringify(token));
  localStorage.setItem('user', JSON.stringify(response.data?.data));
  localStorage.setItem('role', JSON.stringify(response?.data?.data));
  dispatch({ type: 'LOGIN', payload: response.data?.data });
  dispatch({ type: 'ROLE', payload: response.data?.data });
};

export const userInvitationServices = (method, params, payload, dispatch) => {
  return baseApi(`/accounts/verify-email/`, method, params, payload).then(response => {
    if (method === 'post') {
      setAuthUser(response, dispatch);
    }
    return response.data;
  });
};

export const museumList = (method, payload = null, params = null, header) => {
  return baseApi(`/museums/`, method, params, payload, header).then(response => {
    return response.data;
  });
};

export const researchList = (method, payload = null, params = null) => {
  return baseApi(`/materials/`, method, params, payload).then(response => {
    return response.data;
  });
};

/**
 * forgot password api
 * */

export const passwordServices = (method, payload = null, params = null) => {
  return baseApi(`/users/passwords`, method, params, payload).then(response => {
    return response.data;
  });
};

/**
 * reset password api
 * */
export const passwordResetServices = (method, payload, dispatch) => {
  return baseApi(`/users/password`, method, null, payload).then(response => {
    if (method === 'put') {
      setAuthUser(response, dispatch);
    }
    return response.data;
  });
};